const TableEmptyRow = ({
  colSpan,
  title,
  description,
  filteredTitle,
  filteredDescription = "Try clearing search or filters, or adjust your criteria to see results here.",
  message = "No results found",
  emptyMessage,
  searchMessage,
  searchQuery = "",
  hasActiveFilters = false,
  onClearSearch,
  onClearFilters,
  clearFiltersLabel = "Clear filters",
  onAdd,
  addLabel,
  icon = "fi fi-rr-box",
  variant = "rich",
}) => {
  const isFiltered = hasActiveFilters || !!searchQuery;

  const displayTitle =
    title ||
    (isFiltered
      ? filteredTitle ||
        searchMessage ||
        (typeof emptyMessage === "string" && emptyMessage.includes("match")
          ? emptyMessage
          : "No results match your filters")
      : emptyMessage || message || "No results found");

  const displayDescription = isFiltered ? filteredDescription : description;

  const handleClear = onClearFilters || onClearSearch;

  if (variant === "simple") {
    return (
      <tr>
        <td colSpan={colSpan} className="px-4 py-8 text-center text-sm text-gray-500">
          {icon ? <i className={`${icon} mb-2 block text-4xl text-gray-300`} /> : null}
          <p>{displayTitle}</p>
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td colSpan={colSpan} className="px-4 py-0">
        <div className="flex flex-col items-center justify-center text-center py-16 sm:py-20 px-6 border border-dashed border-gray-200 rounded-lg bg-gray-50/80 m-4">
          <div className="w-14 h-14 rounded-2xl bg-white border border-gray-200 shadow-sm flex items-center justify-center mb-4">
            <i className={`${icon} text-2xl text-gray-400`} aria-hidden />
          </div>
          <h3 className="text-base font-semibold text-gray-900">{displayTitle}</h3>
          {displayDescription ? (
            <p className="text-sm text-gray-500 mt-1 max-w-md">{displayDescription}</p>
          ) : null}
          {(handleClear && isFiltered) || (onAdd && addLabel) ? (
            <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
              {handleClear && isFiltered ? (
                <button
                  type="button"
                  onClick={handleClear}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  {clearFiltersLabel}
                </button>
              ) : null}
              {onAdd && addLabel ? (
                <button
                  type="button"
                  onClick={onAdd}
                  className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg border border-primary shadow-sm hover:bg-primary/90 transition-colors inline-flex items-center gap-2"
                >
                  <i className="fi fi-rr-plus text-xs" aria-hidden />
                  {addLabel}
                </button>
              ) : null}
            </div>
          ) : null}
        </div>
      </td>
    </tr>
  );
};

export default TableEmptyRow;
